// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'jquery'
import '@/assets/css/global.css' //引入公共的css样式
import '@/assets/js/global.js' //引入公共的js
Vue.config.productionTip = false


//vuex引入使用
import store from './store'


// 按需注册 Vant 组件
import { Tab, Tabs } from 'vant';
Vue.use(Tab).use(Tabs);
import 'vant/lib/index.css';

// import wxapi from '@/public/wxapi.js'
// Vue.use(wxapi)

//引入element-ui，并全局使用
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
//引入mintui，并全局使用
import Mint from 'mint-ui';
import 'mint-ui/lib/style.css'
Vue.use(Mint);
//全局配置使用axios
import axios from 'axios'
Vue.prototype.$axios = axios;
router.beforeEach((to, from, next) => {
  var pa = to.path
  if (pa.indexOf('/admin/') != -1) {
    axios.interceptors.request.use(function (config) {
      var token = window.sessionStorage.getItem('token')
      // console.log(token)
      config.headers.token = token
      return config
    }, function (error) {
      return Promise.reject(error)
    })
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {//判断是否有标题
	  // console.log(to.meta.title)
    document.title = to.meta.title
  }else{
    if(to.path == '/items/3.html') {
      document.title = '网站建设-石家庄飞天科技'
    } else if(to.path == '/items/4.html') {
      document.title = '微信营销-石家庄飞天科技'
    } else if(to.path == '/items/5.html') {
      document.title = '软件开发-石家庄飞天科技'
    } else if(to.path == '/items/6.html') {
      document.title = '品牌设计-石家庄飞天科技'
    } else if(to.path == '/webcase/101.html') {
      document.title = '客户案例-石家庄飞天科技'
    } else if(to.path == '/') {
      document.title = store.state.title
    } 
    // document.title = 'to.meta.title'
  }
  next()
})
//全局配置使用轮播图
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)
// 引入vue-meta
import Meta from 'vue-meta'
Vue.use(Meta)
// 引入百度地图
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  /* Visit http://lbsyun.baidu.com/apiconsole/key for details about app key. */
  ak: 'YOUR_APP_KEY'
})
/* eslint-disable no-new */
// 引入百度的富文本编辑器，并全局配置
import VueUeditorWrap from 'vue-ueditor-wrap'
Vue.component('vue-ueditor-wrap', VueUeditorWrap)
// md5加密
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
//vuerouter报错处理
import Router from 'vue-router'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js